exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-redirect-link[data-v-4b893ef1]{color:#ed565b;font-size:16px;text-decoration:underline;cursor:pointer}", ""]);

// exports
